/**
 * Created by iamso on 24.05.19.
 */

MultiColorCell.prototype.explodeDuration = function () {
    return 1.2;
};